import actions from '../helper/action'
const session = (state = null, action) => {
	if (action.type == actions.ACTION_UPDATE_USER_SESSION) {
		return action != null ? action.payload : state
	}
	return state
}

export default session


// WEBPACK FOOTER //
// ./src/reducer/session.js